import * as actions from '../redux/actions';

import { ContactForm1, SearchBox1 } from '..';
import React, { useState } from 'react';

import { AboutUsIconSection } from '../common/about-us/AboutUsIconSection';
// import Auth from '../common/Auth/Auth';
import CommonService from '../../../services/commonService';
import Footer3 from '../common/footer/Footer3';
import HeroSection from '../common/HeroSection/HeroSection';
import MultiSlider from '../common/MultiSlider/MultiSlider';
import StartPopup from '../common/popup/StartPopup';
import ZoomSlider from '../common/ZoomSlider/ZoomSlider';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import dest1 from './../assets/tepual/destinations/dest1.jpg';
import dest2 from './../assets/tepual/destinations/dest2.jpg';
import dest3 from './../assets/tepual/destinations/dest3.jpg';
import dest4 from './../assets/tepual/destinations/dest4.jpg';
import dest5 from './../assets/tepual/destinations/dest5.jpg';
import dest6 from './../assets/tepual/destinations/dest6.jpg';
import teupalContactBg from '../assets/tepual/home/home-background.jpg';
import teupalIcon1 from '../assets/tepual/icons/camera-about-us.svg';
import teupalIcon2 from './../assets/tepual/icons/urban-about-us.svg';
import teupalIcon3 from './../assets/tepual/icons/location-about-us.svg';
import { useTranslation } from 'react-i18next';

const metaData = CommonService.getLocal('metaData');
const operator = metaData && metaData.operator_sites ? metaData.operator_sites.operator : '';

const slides = [
	'https://i.imgur.com/Yszno5e.jpg',
	'https://i.imgur.com/ZBzbir7.jpg',
	'https://i.imgur.com/xpeJkkR.jpg',
	'https://i.imgur.com/0NAc45h.jpg',
];

const multiSlides = [dest1, dest2, dest3, dest4, dest5, dest6];

const teupalIconsAndTexts = [
	{ icon: teupalIcon1, caption: 'Giras de estudio' },
	{ icon: teupalIcon2, caption: 'Transporte interurbano' },
	{ icon: teupalIcon3, caption: 'Viajes especiales' },
];

const getIconsAndTexts = domainName => {
	console.log('Operator is-----', domainName);
	domainName = domainName.operator_name;

	if (domainName === 'tepual.pasaje.cl' || domainName === 'tepual.cl') {
		return teupalIconsAndTexts;
	} else if (domainName === 'saupaola.pasaje.cl' || domainName === 'saupaola.cl') {
		return teupalIconsAndTexts;
	} else {
		return teupalIconsAndTexts;
	}
};

const Theme4 = ({ history, operator, common, pbPaymentDetails, t }) => {
	const backgroundContactSection = teupalContactBg;

	// const { t, i18n } = useTranslation();

	const [showPopup, setShowPopup] = useState(true);

	const [showAuth, setShowAuth] = useState(true);

	return (
		<div>
			{/* <Auth
        showModal={showAuth}
        onHide={() => setShowAuth(false)}
        common={common}
        pbPaymentDetails={pbPaymentDetails}
        metaData={metaData}
        actions={actions}
        t={t}
        onLoginSuccess={() => actions.openCloseLoginModal(false)}
        onSignupSuccess={() => actions.openCloseLoginModal(false)}
        history={history}
      /> */}
			{/* <Footer3 /> */}

			{/* <StartPopup showPopup={showPopup} setShowpop={setShowPopup} imageSource={teupalIcon1} />

      <div style={{ position: 'relative' }} className="margin-top-show-header">
        {slides && slides.length > 1 ? (
          <ZoomSlider slides={slides} height={'80vh'} />
        ) : (
          <HeroSection
            heroImage={slides[0]}
            height={'80vh'}
            // height={'50vh'}
            // title={'Galeria'}
            // description={'Home / Galera'}
          />
        )}
        <div style={styles.searchBoxOverlay}>
          <SearchBox1 history={history} operator={operator} />
        </div>
      </div>

      <AboutUsIconSection
        // smallHeading={'Conoce'}
        // boldHeading={'NUESTROS SERVICIOS'}
        iconsAndTexts={getIconsAndTexts(operator)}
      />

      <div className="new-container">
        <MultiSlider
          smallHeading="Conoce"
          boldHeading="NUESTROS DESTINOS"
          multiSlides={multiSlides}
        />
      </div>

      <div className="theme5-contact-home-banner">
        <img src={backgroundContactSection} alt="" />
      </div>

      <div className="theme5-contact">
        <ContactForm1 operator={operator} />
      </div> */}
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
		common: state.common,
		pbPaymentDetails: state.pbPaymentDetails,
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

const styles = {
	searchBoxOverlay: {
		position: 'absolute',
		height: '100%',
		width: '100%',
		top: 0,
		zIndex: 10,
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
	},
};

export default connect(mapStateToProps, mapDispatchToProps)(Theme4);



// WEBPACK FOOTER //
// ./src/features/themes/theme4/Theme4.js